import CheckIcon from '@heroicons/react/24/outline/CheckIcon';
import ChevronDownIcon from '@heroicons/react/24/outline/ChevronDownIcon';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';

import { Button } from '@/components/core/Button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/core/DropdownMenu/DropdownMenu';
import { useTranslation } from '@/hooks/useTranslation';
import { cn } from '@/services/utils';

const TAG_SORT_ALPHABETICAL = 'alphabetical';

const menuItemClassName = cn(
    'tw-flex tw-cursor-pointer tw-select-none tw-items-start tw-gap-2 tw-rounded tw-px-3 tw-py-2 tw-text-t-sm tw-text-t-primary tw-outline-none lg:tw-text-t-base',
    'data-[highlighted]:tw-bg-fill-primary-hover',
);

/**
 * "Sorting: Alphabetical" of the tags panel and the bulk tag dialog. Tags sort
 * alphabetically only (D-035, D-038); the menu keeps its slot with one entry.
 */
function DamTagSortMenu() {
    const { t } = useTranslation();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost">
                    <span>{t('DAM.LIBRARY.SORTING')} {t('DAM.LIBRARY.TAG_SORT.ALPHABETICAL')}</span>
                    <ChevronDownIcon aria-hidden className="tw-h-4 tw-w-4 tw-icon-primary" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" hasBorder hasPadding={false} className="tw-w-56 tw-py-2">
                <DropdownMenuPrimitive.RadioGroup value={TAG_SORT_ALPHABETICAL}>
                    <DropdownMenuPrimitive.RadioItem value={TAG_SORT_ALPHABETICAL} className={menuItemClassName}>
                        <span className="tw-mt-0.5 tw-inline-flex tw-h-4 tw-w-4 tw-shrink-0">
                            <DropdownMenuPrimitive.ItemIndicator>
                                <CheckIcon aria-hidden className="tw-h-4 tw-w-4 tw-icon-primary" />
                            </DropdownMenuPrimitive.ItemIndicator>
                        </span>
                        <span>{t('DAM.LIBRARY.TAG_SORT.ALPHABETICAL')}</span>
                    </DropdownMenuPrimitive.RadioItem>
                </DropdownMenuPrimitive.RadioGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

export { DamTagSortMenu };
